import { useMemo } from 'react';
import { BigNum, QUOTE_PRECISION_EXP } from '@drift-labs/sdk';
import useReferrerNameAccounts from 'src/hooks/useReferrerNameAccounts';
import useAuthorityReferralSnapshots from 'src/hooks/query/snapshots/authority/useAuthorityReferralSnapshots';

export default function usePortfolioReferralData() {
	const { referrerNameAccounts } = useReferrerNameAccounts();

	const { data, ...rest } = useAuthorityReferralSnapshots({
		authority: referrerNameAccounts.accounts[0]?.authority.toString(),
		days: 30,
	});

	const sortedSnapshots = useMemo(() => {
		if (!data?.data.snapshots) {
			return [];
		}

		return [...data.data.snapshots].sort((a, b) => a.ts - b.ts);
	}, [data]);

	const { referralRewards, referredVolume30D, referralCount } = useMemo(() => {
		const latestSnapshot = sortedSnapshots[sortedSnapshots.length - 1];

		const referralRewards = BigNum.fromPrint(
			(latestSnapshot?.referralRewards ?? 0).toString(),
			QUOTE_PRECISION_EXP
		);

		const referredVolume30D = BigNum.fromPrint(
			(latestSnapshot?.referredVolume30D ?? 0).toString(),
			QUOTE_PRECISION_EXP
		);

		const referralCount = BigNum.fromPrint(
			(latestSnapshot?.referralCount ?? 0).toString()
		);

		return { referralRewards, referredVolume30D, referralCount };
	}, [sortedSnapshots]);

	return {
		data: {
			referrerNameAccounts,
			referralRewards,
			referralCount,
			referredVolume30D,
		},
		...rest,
	};
}
